export default "__VITE_ASSET__DDicQVSj__"